import { render, staticRenderFns } from "./Joker2.vue?vue&type=template&id=09986efe&scoped=true"
import script from "./Joker2.vue?vue&type=script&lang=js"
export * from "./Joker2.vue?vue&type=script&lang=js"
import style0 from "./Joker2.vue?vue&type=style&index=0&id=09986efe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09986efe",
  null
  
)

export default component.exports